import React, { useContext, useEffect, useState } from "react";
import { Flex, Input, Heading, TextArea, Select, Text, Checkbox, MRadio, MNotification, Button } from "@cisco/spaces-dash-lib-styleguide";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import { I18nContext } from "../../../contexts/i18nContext";
import "./app-center-tab.scss";
import ImageUpload from "../image-upload/image-upload";

function AppCenterTab(props) {
  const { app, setApp, industryFilter, sgRegionAvailable, euRegionAvailable } = props;
  const { setToastMessage } = useNotification();
  const i18n = useContext(I18nContext);
  const [filePath, setFilePath] = useState("");
  // const [appIconS3Url, setAppIconS3Url] = useState("");
  // const [companyLogoS3Url, setCompanyLogoS3Url] = useState("");

  const createObjectFromDotSeparatedString = (str) => {
    return str.split(".").reduce((acc, current) => {
      if (!acc[current]) {
        acc[current] = {};
      }
      return acc[current];
    }, {});
  };

  // const getS3Image = (p, k) => {
  //   const imgPathObj = {
  //     path: p
  //   };
  //   PartnerDashboardService.readFileFromS3(imgPathObj)
  //     .then((response) => {
  //       if (response) {
  //         const txt = response;
  //         // const url = URL.createObjectURL(blob);
  //         if (k === "appIconS3Url") {
  //           setAppIconS3Url(txt);
  //         } else if (k === "companyLogoS3Url") {
  //           setCompanyLogoS3Url(txt);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       // setToastMessage(
  //       //   t("app-settings.component-success-msg-1"),
  //       //   4000,
  //       //   "negative"
  //       // );
  //     });
  // };

  const handleInput = (event, field) => {
    const newEditingNode = { ...app };
    if (field.indexOf(".") > -1) {
      if (newEditingNode[field]) {
        newEditingNode[field] = event.target.value;
      } else {
        const firstField = field.split(".")[0];
        const firstFieldObject = createObjectFromDotSeparatedString(field);
        newEditingNode[firstField] = firstFieldObject;
        newEditingNode[field] = event.target.value;
      }
    } else {
      newEditingNode[field] = event.target.value;
    }
    setApp(newEditingNode);
  };

  const handleDeveloperInfoInput = (event, field) => {
    const newEditingNode = { ...app };
    if (newEditingNode.developerInfo) {
      newEditingNode.developerInfo[field] = event.target.value;
    }
    setApp(newEditingNode);
    // if (newEditingNode.developerInfo.companyLogoS3Url) {
    //   getS3Image(newEditingNode.developerInfo.companyLogoS3Url, "companyLogoS3Url");
    // }
  };

  const handleYoutubeInput = (event) => {
    const newEditingNode = { ...app };
    if (newEditingNode.appMedia && newEditingNode.appMedia.video) {
      newEditingNode.appMedia.video = [];
      newEditingNode.appMedia.video.push({ url: event.target.value });
    }
    setApp(newEditingNode);
  };

  useEffect(() => {
    console.log("AppCenterTab Mount");
    if (app.appId) {
      const fPath = `partner/apps/${sessionStorage.getItem("tenantId")}/${app.appId}`;
      setFilePath(fPath);
    }
    // if (app.appIconS3Url) {
    //   getS3Image(app.appIconS3Url, "appIconS3Url");
    // }
    // if (app.developerInfo.companyLogoS3Url) {
    //   getS3Image(app.developerInfo.companyLogoS3Url, "companyLogoS3Url");
    // }
    return () => {
      console.log("AppCenterTab Destroy");
    };
  }, []);

  const appRegionSelection = (val) => {
    console.log("createAppTypeSelection", val);
    handleInput({ target: { value: val?.target?.value } }, "region");
  };

  const onClickIndustry = (val) => {
    console.log("Industry", val);
    handleInput({ target: { value: val } }, "primaryVertical");

    if (val && app.verticals && app.verticals.length && app.verticals.indexOf(val) > -1) {
      const appVerticalCopy = [...app.verticals];
      const verticalIndex = appVerticalCopy.indexOf(val);
      appVerticalCopy.splice(verticalIndex, 1);
      handleInput({ target: { value: appVerticalCopy } }, "verticals");
    }
  };

  const onClickVertical = (val) => {
    console.log("Vertical", val);
    let appVerticalCopy = [];
    if (app.verticals && app.verticals.length) {
      appVerticalCopy = [...app.verticals];
    }
    const verticalIndex = appVerticalCopy.indexOf(val);
    if (verticalIndex > -1) {
      appVerticalCopy.splice(verticalIndex, 1);
    } else {
      appVerticalCopy.push(val);
    }
    handleInput({ target: { value: appVerticalCopy } }, "verticals");
  };

  // const handleFileChange = (e) => {
  //   if (e.target.files) {
  //     let formData = new FormData();
  //     formData.append("file", e.target.files[0]);
  //     formData.append("filePath", "apps/1857/33cbf5651b90438eb269374d5133022744b55cb12")
  //     fetch('/client/v1/partner/uploadImage', {
  //           method: 'POST',
  //           body: formData
  //       })
  //       .then((response) => {
  //           if (response) {
  //             console.log(response.data);
  //             setToastMessage(
  //               t("app-settings.component-success-msg-1"),
  //               4000,
  //               "positive"
  //             );
  //           }
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //           setToastMessage(
  //             t("app-settings.component-success-msg-1"),
  //             4000,
  //             "negative"
  //           );
  //         });
  //     try {
  //       let fileForm = new FormData();
  //       fileForm.append("file", e.target.files[0]);
  //       fileForm.append("filePath", filePath)
  //       PartnerDashboardService.fileUploadToS3(fileForm)
  //         .then((response) => {
  //           if (response) {
  //             console.log(response.data);
  //             setToastMessage(
  //               t("app-settings.component-success-msg-1"),
  //               4000,
  //               "positive"
  //             );
  //           }
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //           setToastMessage(
  //             t("app-settings.component-success-msg-1"),
  //             4000,
  //             "negative"
  //           );
  //         });
  //     } catch (error) {
  //       console.error(error);
  //       setToastMessage(
  //         t("app-settings.component-success-msg-1"),
  //         4000,
  //         "negative"
  //       );
  //     }
  //   }
  // };

  const checkboxTemplate = (industry, index) => {
    return (
      <Checkbox
        key={index}
        onClick={() => onClickVertical(industry.value)}
        checked={app.verticals && app.verticals.length && app.verticals.indexOf(industry.value) > -1}
        disabled={app.primaryVertical === industry.value}
      >
        {industry.label}
      </Checkbox>
    );
  };

  const removeScreenshot = (index) => {
    const newEditingNode = { ...app };
    newEditingNode.appMedia.image.splice(index, 1);
    setApp(newEditingNode);
  };

  const appMediaImageTemplate = (src, index) => {
    return (
      <div key={index} className="imgContainer">
        <img className="icon-image" src={src.imgIconS3Url} alt={src.altText || "App Media"} />
        <div className="imgRemoveBtn">
          <Button kind="tertiary" onClick={() => removeScreenshot(index)}>
            {i18n.t("partner-dashboard-app.partner-apps.app-settings.remove-text")}
          </Button>
        </div>
      </div>
    );
  };

  const getVideoUrl = (url) => {
    if (url) {
      let ytId = "";
      if (url.includes("youtu.be")) {
        [, ytId] = url.split("youtu.be/");
      } else if (url.includes("youtube.com")) {
        [, ytId] = url.split("v=");
        const andPos = ytId.indexOf("&");
        if (andPos != -1) {
          ytId = ytId.substring(0, andPos);
        }
      }
      return ytId;
    }
    return "";
  };

  const showInvalidImageMsg = () => {
    setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-center.upload-proper-image-msg"), 4000, "negative");
  };

  const saveImagePath = (path, type, name) => {
    if (type == "icon") {
      const newEditingNode = { ...app };
      newEditingNode.appIconS3Url = path;
      newEditingNode.appIcon = name;
      setApp(newEditingNode);
      // getS3Image(newEditingNode.appIconS3Url, "appIconS3Url");
    } else if (type == "logo") {
      // handleDeveloperInfoInput({ target: { value: name } }, "companyLogo");
      handleDeveloperInfoInput({ target: { value: path } }, "companyLogoS3Url");
    } else if (type == "image") {
      const obj = {
        imgIcon: name,
        imgIconS3Url: path
      };
      const newEditingNode = { ...app };
      if (newEditingNode.appMedia) {
        if (newEditingNode.appMedia.image) {
          newEditingNode.appMedia.image.push(obj);
        } else {
          newEditingNode.appMedia.image = [];
          newEditingNode.appMedia.image.push(obj);
        }
      } else {
        newEditingNode.appMedia = {};
        newEditingNode.appMedia.image = [];
        newEditingNode.appMedia.image.push(obj);
      }
      setApp(newEditingNode);
    }
  };

  return (
    <div className="pBottom40">
      <div>
        <div className="leftLayout">
          <Flex direction="vertical" gap={16}>
            <Flex direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-information-text")}</Heading>
              <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.fields-marked-mandatory-text")}</Heading>
            </Flex>
            <Flex direction="vertical" gap={8}>
              <Text>
                {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.choose-the-region-text")}
                <span className="mds-rebuild-input-label-required">*</span>
              </Text>
              <Text>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.based-on-region-select")}</Text>
              {!euRegionAvailable && (
                <div
                  style={{
                    "max-width": "660px"
                  }}
                >
                  <MNotification status="warning">
                    {/* {i18n.t("partner-dashboard-app.partner-apps.app-center.note-text")}
                    {": "} */}
                    {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.looks-no-account-on-eu-region")}
                  </MNotification>
                </div>
              )}
              {!sgRegionAvailable && (
                <div
                  style={{
                    "max-width": "660px"
                  }}
                >
                  <MNotification status="warning">
                    {/* {i18n.t("partner-dashboard-app.partner-apps.app-center.note-text")}
                    {": "} */}
                    {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.looks-no-account-on-singapore-region")}
                  </MNotification>
                </div>
              )}
            </Flex>
            <Flex direction="vertical" gap={8}>
              <MRadio
                direction="horizontal"
                onChange={appRegionSelection}
                value={app.region}
                options={[
                  {
                    key: 1,
                    disabled: !euRegionAvailable,
                    label: i18n.t("partner-dashboard-app.partner-apps.partner-app-center.europe-region-text"),
                    value: "eu"
                  },
                  {
                    key: 2,
                    disabled: !sgRegionAvailable,
                    label: i18n.t("partner-dashboard-app.partner-apps.partner-app-center.singapore-region-text"),
                    value: "sg"
                  },
                  {
                    key: 3,
                    label: i18n.t("partner-dashboard-app.partner-apps.partner-app-center.rest-of-world-text"),
                    value: "us"
                  }
                ]}
                size="md"
              />
            </Flex>
            <Flex direction="vertical" gap={8} />
            <Flex direction="vertical" gap={8} />
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Input
                id="app-name-input"
                size="md"
                onChange={(e) => {
                  handleInput(e, "appName");
                }}
                value={app.appName}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-name-text")}
                required
                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-app-name")}
              />
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Input
                id="app-tagline-input"
                size="md"
                onChange={(e) => {
                  handleInput(e, "appTagLine");
                }}
                value={app.appTagLine}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-tagline-text")}
                required
                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-app-tagline")}
              />
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Text className="mds-rebuild-input-size-md" style={{ fontWeight: 600 }}>
                {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-icon-text")}
                <span className="mds-rebuild-input-label-required">*</span>
              </Text>
              <Flex gap={2}>{app && app.appIconS3Url ? <img width={100} src={app.appIconS3Url} alt="App Icon" /> : ""}</Flex>
              <Flex className="formMaxWidth" direction="vertical" gap={2}>
                <ImageUpload fileId="appIcon" path={filePath} type="icon" showInvalidImageMsg={showInvalidImageMsg} saveImagePath={saveImagePath} />
              </Flex>
              {/* <input id="file" type="file" onChange={handleFileChange} /> */}
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <TextArea
                id="app-description-input"
                onChange={(e) => {
                  handleInput(e, "appDescription");
                }}
                value={app.appDescription}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-description-text")}
                required
                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-app-description")}
              />
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              {industryFilter && industryFilter.length && (
                <div>
                  <Text className="mds-rebuild-input-size-md">
                    {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.primary-industry-text")}
                    <span className="mds-rebuild-input-label-required">*</span>
                  </Text>
                  <Select
                    onChange={onClickIndustry}
                    options={industryFilter}
                    id="primary-industry-dropdown"
                    placeholder={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.primary-industry-text")}
                    value={app.primaryVertical}
                  />
                </div>
              )}
            </Flex>
            <Flex direction="vertical" gap={8}>
              <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.more-industries-text")}</Text>
              <Flex wrap className="formMaxWidth2" direction="horizontal" gap={24}>
                {industryFilter && industryFilter.map((vertical, index) => checkboxTemplate(vertical, index))}
              </Flex>
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              {app.verticals && app.verticals.length && app.verticals.indexOf("others") > -1 ? (
                <Input
                  size="md"
                  onChange={(e) => {
                    handleInput(e, "otherVertical");
                  }}
                  value={app.otherVertical}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.other-industry-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-other-industry")}
                />
              ) : (
                ""
              )}
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.developer-info-text")}</Heading>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.company-logo-text")}</Text>
                <Flex gap={2}>
                  {/* {companyLogoS3Url ? <div dangerouslySetInnerHTML={{ __html: companyLogoS3Url }} /> : ""} */}
                  {app && app.developerInfo && app.developerInfo.companyLogoS3Url ? (
                    <img className="icon-image" src={app.developerInfo.companyLogoS3Url} alt="Company Logo" width={200} height={100} />
                  ) : (
                    ""
                  )}
                </Flex>
                <Flex className="formMaxWidth" direction="vertical" gap={2}>
                  <ImageUpload fileId="companyLogo" path={filePath} type="logo" showInvalidImageMsg={showInvalidImageMsg} saveImagePath={saveImagePath} />
                </Flex>
                {/* <input id="file" type="file" onChange={handleFileChange} /> */}
              </Flex>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "companyName");
                  }}
                  value={app.developerInfo?.companyName}
                  label={i18n.t("partner-dashboard-app.placeholders.enter-company-name")}
                  placeholder={i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.company-name-text")}
                />
              </Flex>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "companyWebsite");
                  }}
                  value={app.developerInfo?.companyWebsite}
                  label={i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.company-website-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-company-website")}
                />
              </Flex>
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.support-contact-text")}</Heading>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "supportPhone");
                  }}
                  value={app.developerInfo?.supportPhone}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.support-phone-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-support-phone")}
                />
              </Flex>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "supportEmail");
                  }}
                  value={app.developerInfo?.supportEmail}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.support-email-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-support-email")}
                />
              </Flex>
            </Flex>
            <Flex className="formMaxWidth" direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.sales-contact-text")}</Heading>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "salesPhone");
                  }}
                  value={app.developerInfo?.salesPhone}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.sales-phone-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-sales-phone")}
                />
              </Flex>
              <Flex className="formMaxWidth" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleDeveloperInfoInput(e, "salesEmail");
                  }}
                  value={app.developerInfo?.salesEmail}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-app-center.sales-email-text")}
                  placeholder={i18n.t("partner-dashboard-app.placeholders.enter-sales-email")}
                />
              </Flex>
            </Flex>
          </Flex>
        </div>
        <div className="rightLayout">
          <Flex direction="vertical" gap={16}>
            <Flex direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.app-media-text")}</Heading>
              <div>{i18n.t("partner-dashboard-app.partner-apps.customer-app-usecase.screen-shots-text")}</div>
              <div>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.suggested-size-text")}: 1240x720px</div>
            </Flex>
            <Flex direction="vertical" gap={4}>
              <ImageUpload fileId="appMedia" path={filePath} type="image" showInvalidImageMsg={showInvalidImageMsg} saveImagePath={saveImagePath} />
            </Flex>
            <Flex direction="vertical" gap={4}>
              {app.appMedia && app.appMedia.image && app.appMedia.image.length ? app.appMedia.image.map((img, index) => appMediaImageTemplate(img, index)) : ""}
            </Flex>
            {/* <div class="imagesList" *ngIf="
            localConfig['appMedia'] &&
            localConfig['appMedia']['image'] &&
            localConfig['appMedia']['image'].length
          ">
          <div *ngFor="let img of localConfig['appMedia']['image']; let j = index">
            <div class="imgContainer">
              <img [src]="img.imgIconS3Url" alt="App Icon" class="appMediaImg" />
            </div>
            <div class="removeContainer" *ngIf="!viewApp">
              <span (click)="removeImgAsset(img, j)"
                class="removeImgLink">{{'partner-dashboard-app.partner-apps.app-settings.remove-text' | translate}}</span>
            </div>
          </div>
        </div> */}
            <Flex direction="vertical" gap={8} />
            <Flex direction="vertical" gap={8}>
              <Input
                size="md"
                onChange={(e) => {
                  handleYoutubeInput(e);
                }}
                value={app.appMedia?.video?.[0]?.url}
                label={i18n.t("partner-dashboard-app.placeholders.you-tube-video-url")}
                placeholder={i18n.t("partner-dashboard-app.placeholders.you-tube-video-url")}
              />
            </Flex>
            <Flex direction="vertical" gap={8}>
              <iframe
                title={`${app.appId}-media`}
                style={{
                  width: "100%",
                  height: "315px"
                }}
                src={`//www.youtube.com/embed/${getVideoUrl(app.appMedia?.video?.[0]?.url)}`}
              />
            </Flex>
          </Flex>
        </div>
      </div>
    </div>
  );
}

export default AppCenterTab;
